export default __webpack_public_path__ + "images/0xe992beab6659bff447893641a378fbbf031c5bd6.png";